import {
    LOGOUT,
    // O365_REGISTER_REQUEST,
    // O365_REGISTER_SUCCESS,
    // O365_REGISTER_FAILURE,
    BSRS_LOGIN_REQUEST,
    BSRS_LOGIN_SUCCESS,
    BSRS_LOGIN_FAILURE,
    // PROFILE_LOGIN_REQUEST,
    // PROFILE_LOGIN_SUCCESS,
    // PROFILE_LOGIN_FAILURE,
    // BSRS_SERVICE_TOKEN_REQUEST,
    // BSRS_SERVICE_TOKEN_SUCCESS,
    // BSRS_SERVICE_TOKEN_FAILURE,

    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS,
    CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE,
} from '../../types'

import { clearBSRSToken, setBSRSToken, CORE_API_ENDPOINT, PREFIX, clearToken } from 'Lib'
import { CALL_API } from 'Middlewares'

export function authorizeBSRS({ email, password }, history) {
    let body = { email: email, password: password }
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/adminverify/`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            types: [
                BSRS_LOGIN_REQUEST,
                {
                    type: BSRS_LOGIN_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                const {
                                    token,
                                    data,
                                    result_per_page
                                } = json.value
                                const { role, userId, isFirstChangePassword } = data
                                if (role !== 'admin' && role !== 'superadmin')
                                    window.location.replace(`${PREFIX}/withoutpermission`)
                                else {
                                    let loginData = { token, role, userId, result_per_page, isFirstChangePassword }
                                    setBSRSToken(loginData)
                                }
                                return { token, role, data }
                            })
                    }
                },
                BSRS_LOGIN_FAILURE
            ]
        }
    }
}

export function requestChangePassword(userId) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/resetpassword/${userId}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            types: [
                CORE_SEND_EMAIL_REQ_RESET_PASSWORD_REQUEST,
                {
                    type: CORE_SEND_EMAIL_REQ_RESET_PASSWORD_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(
                                json => {
                                    return json.value
                                }
                            )
                    }
                },
                CORE_SEND_EMAIL_REQ_RESET_PASSWORD_FAILURE
            ]
        }
    }
}

export function logout() {
    clearBSRSToken()
    clearToken()

    return {
        type: LOGOUT
    }
}


// WEBPACK FOOTER //
// ./src/features/auth/actions.js